const _excluded = ["text", "paymentMethodType", "parenthesisText", "icon", "selected", "className", "disabled", "mobileView", "children", "onOptionClick", "data-testid"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { RadioButton, Typography } from 'seagull';
import { Collapse } from '@material-ui/core';
import styles from "./PaymentMethodOption.module.scss";
const paymentMethodTypeTextMap = {
  bankAccount: 'Bank account',
  creditCard: 'Credit card'
};
const PaymentMethodOption = /*#__PURE__*/React.forwardRef(function PaymentMethodOption(props, ref) {
  const {
    text = '',
    paymentMethodType,
    parenthesisText,
    icon,
    selected,
    className,
    disabled,
    mobileView,
    children,
    onOptionClick,
    'data-testid': testid
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    "aria-selected": selected,
    className: cn(styles.optionWrapper, {
      [styles.selected]: selected,
      [styles.mobileView]: mobileView,
      [styles.disabled]: disabled
    }, className),
    "data-testid": testid
  }, rest), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.option,
    disabled: disabled,
    onClick: onOptionClick,
    "data-testid": testid && testid + '-button'
  }, mobileView && /*#__PURE__*/React.createElement(RadioButton, {
    checked: selected
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.name
  }, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    skin: disabled || !selected ? 'secondary' : 'standard'
  }, paymentMethodType ? paymentMethodTypeTextMap[paymentMethodType] : text), "\xA0", /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "payment-method-option-parenthesis",
    as: "span",
    variant: "paragraph2",
    weight: "light",
    skin: "secondary"
  }, "(", parenthesisText, ")")), /*#__PURE__*/React.createElement("div", {
    className: disabled || !selected ? styles.iconDisabled : styles.icon
  }, icon)), mobileView && children && /*#__PURE__*/React.createElement(Collapse, {
    in: selected,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.collapsedArea
  }, children)));
});
export default PaymentMethodOption;